import { useToolbarContext } from './useToolbarContext'

export function useTrashModeToolbarState() {
    const { recordsSelectedCount, setIsTrashMode, restoreRecordsSelected } = useToolbarContext()

    const onExitTrash = () => {
        setIsTrashMode(false)
    }

    const hasRecordsSelected = recordsSelectedCount > 0

    const buttonLabel = formatRecordCount(recordsSelectedCount)

    return {
        buttonLabel,
        onExitTrash,
        hasRecordsSelected,
        onRestoreSelected: restoreRecordsSelected,
    }
}

function formatRecordCount(count: number) {
    return count === 1 ? 'Restore record' : `Restore ${count} records`
}
